(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("gje-fetch"), require("gje-error-handler"));
	else if(typeof define === 'function' && define.amd)
		define(["gje-fetch", "gje-error-handler"], factory);
	else if(typeof exports === 'object')
		exports["gje-redux-async"] = factory(require("gje-fetch"), require("gje-error-handler"));
	else
		root["gje-redux-async"] = factory(root["gje-fetch"], root["gje-error-handler"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asyncReducerFactory = exports.asyncPostActionFactory = exports.asyncGetActionFactory = undefined;
	
	var _asyncReducerFactory = __webpack_require__(1);
	
	var _asyncReducerFactory2 = _interopRequireDefault(_asyncReducerFactory);
	
	var _asyncGetActionFactory = __webpack_require__(2);
	
	var _asyncGetActionFactory2 = _interopRequireDefault(_asyncGetActionFactory);
	
	var _asyncPostActionFactory = __webpack_require__(6);
	
	var _asyncPostActionFactory2 = _interopRequireDefault(_asyncPostActionFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.asyncGetActionFactory = _asyncGetActionFactory2.default;
	exports.asyncPostActionFactory = _asyncPostActionFactory2.default;
	exports.asyncReducerFactory = _asyncReducerFactory2.default;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var initialDataValue = _ref.initialDataValue,
	      _ref$actionTypes = _ref.actionTypes,
	      actionTypes = _ref$actionTypes === undefined ? {} : _ref$actionTypes;
	
	  var initialState = {
	    isFetching: false,
	    data: initialDataValue
	  };
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var objectKey = action.objectKey || 'data';
	    switch (action.type) {
	      case actionTypes.REQUEST:
	        return Object.assign({}, state, _defineProperty({
	          isFetching: true,
	          error: undefined
	        }, objectKey, initialDataValue));
	      case actionTypes.RECEIVE:
	        return Object.assign({}, state, _defineProperty({
	          isFetching: false,
	          error: undefined
	        }, objectKey, action.data));
	      case actionTypes.FETCH_ERROR:
	        return Object.assign({}, state, _defineProperty({
	          isFetching: false,
	          error: action.error
	        }, objectKey, initialDataValue));
	      default:
	        return state;
	    }
	  };
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gjeFetch = __webpack_require__(3);
	
	var _gjeFetch2 = _interopRequireDefault(_gjeFetch);
	
	var _errorActions = __webpack_require__(4);
	
	var _gjeErrorHandler = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultResponseHandler = function defaultResponseHandler(response) {
	  return response.data;
	};
	var defaultRemoteLogErrorHandler = (0, _gjeErrorHandler.remoteLogErrorHandler)({});
	
	exports.default = function (_ref) {
	  var actionTypes = _ref.actionTypes,
	      url = _ref.url,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? {} : _ref$options,
	      _ref$responseHandler = _ref.responseHandler,
	      responseHandler = _ref$responseHandler === undefined ? defaultResponseHandler : _ref$responseHandler,
	      errorHandler = _ref.errorHandler,
	      objectKey = _ref.objectKey,
	      _ref$isArray = _ref.isArray,
	      isArray = _ref$isArray === undefined ? false : _ref$isArray,
	      _ref$remoteLogErrorHa = _ref.remoteLogErrorHandler,
	      remoteLogErrorHandler = _ref$remoteLogErrorHa === undefined ? defaultRemoteLogErrorHandler : _ref$remoteLogErrorHa;
	
	  var requestAction = function requestAction() {
	    return { type: actionTypes.REQUEST };
	  };
	
	  var receiveAction = function receiveAction(data) {
	    return {
	      type: actionTypes.RECEIVE,
	      data: data,
	      objectKey: objectKey,
	      isArray: isArray
	    };
	  };
	
	  return function () {
	    return function (dispatch) {
	      dispatch(requestAction());
	      return _gjeFetch2.default.get(url, options).then(function (response) {
	        return response.text();
	      }).then(function (text) {
	        try {
	          return JSON.parse(text);
	        } catch (e) {
	          return text;
	        }
	      }).then(function (content) {
	        dispatch(receiveAction(responseHandler({ data: content })));
	        return Promise.resolve(content);
	      }).catch(function (error) {
	        if (typeof errorHandler === 'function') {
	          var handled = errorHandler(error);
	          if (handled) {
	            dispatch(receiveAction(handled));
	            return;
	          }
	        }
	        dispatch((0, _errorActions.isResponseObj)(error) ? (0, _errorActions.fetchErrorAction)(error, url, actionTypes, remoteLogErrorHandler) : (0, _errorActions.appErrorAction)(error, actionTypes, remoteLogErrorHandler));
	        return Promise.reject(error);
	      });
	    };
	  };
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appErrorAction = exports.fetchErrorAction = exports.isResponseObj = undefined;
	
	var _gjeErrorHandler = __webpack_require__(5);
	
	var isResponseObj = function isResponseObj(error) {
	  return !!error.status && error.statusText;
	};
	
	var fetchErrorAction = function fetchErrorAction(error, url, actionTypes, remoteLogErrorHandler) {
	  var errorMessage = 'Got response ' + error.status + ' (' + error.statusText + ') for url ' + url;
	  remoteLogErrorHandler(errorMessage);
	  return {
	    type: actionTypes.FETCH_ERROR,
	    error: {
	      message: errorMessage,
	      stack: (0, _gjeErrorHandler.errorParser)(error),
	      raw: error,
	      status: error.status
	    }
	  };
	};
	
	var appErrorAction = function appErrorAction(error, actionTypes, remoteLogErrorHandler) {
	  remoteLogErrorHandler(error);
	  return {
	    type: actionTypes.FETCH_ERROR,
	    error: {
	      message: error.message,
	      stack: (0, _gjeErrorHandler.errorParser)(error),
	      raw: error
	    }
	  };
	};
	
	exports.isResponseObj = isResponseObj;
	exports.fetchErrorAction = fetchErrorAction;
	exports.appErrorAction = appErrorAction;

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _gjeFetch = __webpack_require__(3);
	
	var _gjeFetch2 = _interopRequireDefault(_gjeFetch);
	
	var _errorActions = __webpack_require__(4);
	
	var _gjeErrorHandler = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultRemoteLogErrorHandler = (0, _gjeErrorHandler.remoteLogErrorHandler)({});
	
	var defaultResponseHandler = function defaultResponseHandler(response) {
	  return response.json().then(function (json) {
	    return _extends({}, json, {
	      successfulPost: response.ok
	    });
	  });
	};
	
	exports.default = function (_ref) {
	  var actionTypes = _ref.actionTypes,
	      url = _ref.url,
	      _ref$body = _ref.body,
	      body = _ref$body === undefined ? {} : _ref$body,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? {} : _ref$options,
	      _ref$responseHandler = _ref.responseHandler,
	      responseHandler = _ref$responseHandler === undefined ? defaultResponseHandler : _ref$responseHandler,
	      _ref$remoteLogErrorHa = _ref.remoteLogErrorHandler,
	      remoteLogErrorHandler = _ref$remoteLogErrorHa === undefined ? defaultRemoteLogErrorHandler : _ref$remoteLogErrorHa;
	
	
	  var requestAction = function requestAction() {
	    return { type: actionTypes.REQUEST };
	  };
	
	  var receiveAction = function receiveAction(data) {
	    return {
	      type: actionTypes.RECEIVE,
	      data: data
	    };
	  };
	
	  return function () {
	    return function (dispatch) {
	      dispatch(requestAction());
	      return _gjeFetch2.default.postJSON(url, body, options).then(function (response) {
	        return responseHandler(response);
	      }).then(function (data) {
	        dispatch(receiveAction(data));
	        return Promise.resolve(data);
	      }).catch(function (error) {
	        dispatch((0, _errorActions.isResponseObj)(error) ? (0, _errorActions.fetchErrorAction)(error, url, actionTypes, remoteLogErrorHandler) : (0, _errorActions.appErrorAction)(error, actionTypes, remoteLogErrorHandler));
	        return Promise.reject(error);
	      });
	    };
	  };
	};

/***/ }
/******/ ])
});
;
//# sourceMappingURL=gje-redux-async.js.map